import { VMProductInfoDto } from "../vending/VMProductInfoDto";

/**
 * CartItemDto
 */
export class CartItemDto {
  product: VMProductInfoDto;
  quantity: number;
  /**
   * Full params constructor
   * @param product 
   * @param quantity 
   */
  constructor(product: VMProductInfoDto, quantity: number) {
    this.product = product;
    this.quantity = quantity;
  }
}

